import { useAppStore } from '@/store';
import { FC, memo } from 'react';
import { MessageWrapper } from './styles';

export const Message: FC = memo(() => {
  const {
    userSession: {
      persona: { greetings_title, greetings_descriptions },
    },
  } = useAppStore();

  return (
    <MessageWrapper>
      <h4>{greetings_title}</h4>
      <p>{greetings_descriptions}</p>
    </MessageWrapper>
  );
});
